import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const VerifiedBenefitsScreen = () => {
  const navigate = useNavigate();

  const benefits = [
    {
      emoji: "💬",
      title: "Envio de Mensagens",
      description: "Comunique-se livremente com outros usuários"
    },
    {
      emoji: "✨",
      title: "Perfil Confiável", 
      description: "Seu selo garante credibilidade"
    },
    {
      emoji: "🎯",
      title: "Acesso Completo",
      description: "Explore todos os recursos"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-black to-gray-900 flex flex-col">
      {/* Header minimalista */}
      <div className="flex items-center justify-between px-4 py-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/main/profile')}
          className="text-white hover:bg-white/10 p-2"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-sm font-medium text-white/80 uppercase tracking-wider">Verificação</h1>
        <div className="w-8" />
      </div>

      {/* Conteúdo centralizado */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center space-y-6">
          
          {/* Badge emoji */}
          <div className="w-16 h-16 bg-luxury-gold/20 rounded-full flex items-center justify-center mx-auto">
            <span className="text-4xl">🛡️</span>
          </div>

          {/* Título */}
          <div className="space-y-2">
            <h1 className="text-lg font-semibold text-white">Identidade Verificada</h1>
            <p className="text-xs text-white/60 leading-relaxed max-w-sm mx-auto">
              Sua conta foi validada com sucesso. Você é reconhecido como usuário autêntico da plataforma.
            </p>
          </div>

          {/* Status badge */}
          <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-3 py-1.5">
            <div className="w-2 h-2 bg-luxury-gold rounded-full animate-pulse" />
            <span className="text-white/80 text-xs font-medium uppercase tracking-wide">Verificado</span>
          </div>

          {/* Cards de benefícios */}
          <div className="space-y-3 w-full">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-lg p-3 shadow-md">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-500/20 rounded-full flex items-center justify-center">
                  <span className="text-xl">{benefit.emoji}</span>
                </div>
                <div className="text-left flex-1">
                  <h3 className="text-white font-medium text-xs mb-0.5">{benefit.title}</h3>
                  <p className="text-white/60 text-xs line-clamp-1">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <Button 
            onClick={() => navigate('/main/feed')}
            className="w-full bg-luxury-gold hover:bg-luxury-gold/90 text-black font-medium py-2.5 rounded-lg text-sm shadow-lg flex items-center justify-center gap-2"
          >
            <span className="text-base">🚀</span>
            Explorar Plataforma
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VerifiedBenefitsScreen;